var _ContentLoading, _Divider;
import React from 'react';
import { useIntl } from '@lumahealthhq/ui-components';
import { Button, Container, Divider, IconArrowBack, IconButton, Paper, Stack, Toolbar, Typography } from '@lumahealthhq/ui-core';
import ContentLoading from './components/ContentLoading';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function FallbackContainerFormInsuranceDetails(_ref) {
  var patient = _ref.patient,
    hasCustomWrapper = _ref.hasCustomWrapper,
    renderActionButtons = _ref.renderActionButtons;
  var intl = useIntl();
  return /*#__PURE__*/_jsx(Container, {
    maxWidth: false,
    disableGutters: true,
    children: hasCustomWrapper ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ContentLoading, {
        hasCustomWrapper: hasCustomWrapper
      }), renderActionButtons && renderActionButtons({}, {
        disabled: true
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Stack, {
        alignItems: "baseline",
        justifyContent: "space-between",
        direction: "row",
        mb: 3,
        children: /*#__PURE__*/_jsxs(Stack, {
          alignItems: "center",
          direction: "row",
          gap: 2,
          children: [/*#__PURE__*/_jsx(IconButton, {
            "aria-label": intl.formatMessage({
              id: "orvpWh",
              defaultMessage: [{
                "type": 0,
                "value": "Go back"
              }]
            }),
            children: /*#__PURE__*/_jsx(IconArrowBack, {
              sx: function sx(theme) {
                return {
                  color: theme.palette.common.black
                };
              }
            })
          }), patient ? /*#__PURE__*/_jsx(Typography, {
            variant: "h4",
            children: intl.formatMessage({
              id: "nkewZ6",
              defaultMessage: [{
                "type": 0,
                "value": "Demographics for "
              }, {
                "type": 1,
                "value": "patient"
              }]
            }, {
              patient: patient == null ? void 0 : patient.name
            })
          }) : /*#__PURE__*/_jsx(Typography, {
            variant: "h4",
            children: intl.formatMessage({
              id: "/wX7KE",
              defaultMessage: [{
                "type": 0,
                "value": "Demographics"
              }]
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Paper, {
        sx: {
          padding: 2
        },
        children: /*#__PURE__*/_jsxs(Stack, {
          gap: 3,
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "h5",
            mb: 2,
            children: intl.formatMessage({
              id: "dId3mS",
              defaultMessage: [{
                "type": 0,
                "value": "Insurance Information"
              }]
            })
          }), _ContentLoading || (_ContentLoading = /*#__PURE__*/_jsx(ContentLoading, {})), _Divider || (_Divider = /*#__PURE__*/_jsx(Divider, {})), /*#__PURE__*/_jsxs(Toolbar, {
            sx: {
              gap: 1,
              justifyContent: 'flex-end'
            },
            children: [/*#__PURE__*/_jsx(Button, {
              variant: "secondary",
              disabled: true,
              children: intl.formatMessage({
                id: "47FYwb",
                defaultMessage: [{
                  "type": 0,
                  "value": "Cancel"
                }]
              })
            }), /*#__PURE__*/_jsx(Button, {
              variant: "primary",
              disabled: true,
              children: intl.formatMessage({
                id: "jvo0vs",
                defaultMessage: [{
                  "type": 0,
                  "value": "Save"
                }]
              })
            })]
          })]
        })
      })]
    })
  });
}